/**
 * Stable shell resource naming (parity with backend/CDK naming conventions).
 * @param {string} componentName e.g. "provisioning-enablement"
 * @param {string} name e.g. "pp-sg"
 * @param {string} [env] defaults to REACT_APP_DEPLOY_ENV or "dev"
 */
export function formatShellResourceName(componentName, name, env) {
  const e =
    env ||
    (typeof process !== 'undefined' && process.env && process.env.REACT_APP_DEPLOY_ENV) ||
    'dev';
  return `ifx-wb-${componentName}-${name}-${e}`;
}

/** VPC peering connection Name tag: ifx-wb-webapp-usecase-peering-{env} (use in CDK / Lambda create_tags). */
export function formatWebappUsecasePeeringName(env) {
  return formatShellResourceName('webapp', 'usecase-peering', env);
}
